const debug = false;

const AppConfig = {
  app_name: "Lasaa Application Portal",
  business_name: "Lasaa Portal",
  business_website: "https://lasaa.lg.gov.ng",
  api_base_url: debug ? "http://127.0.0.1:8000/v1/" : "https://lasaaapi.laddar.africa/v1/",
  api_media_url: debug ? "http://127.0.0.1:8000/media/" : "https://lasaaapi.laddar.africa/media/",
  session_object_storage_label: "_lasaa_ws_session_object_",
  session_storage_label: "_lasaa_ws_session_",
  auth_token: "_lasaa_auth_token",
};

export default AppConfig;
